module.exports = __webpack_public_path__ + "f86af030609b638bc446d5bf2475a748.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/greg.jpg
// module id = l/kd
// module chunks = 13